import React from "react";
import "./AboutPage.css";
import { ReactComponent as About } from "../../images/about.svg";
import { Link } from "react-router-dom";
import Title from "../../components/Title/Title";

const AboutPage = () => {
  return (
    <>
      <div className="about-container">
        <div className="back-btn ">
          <Link to="/">
            <button className="backtohome">&#60; Back to Home</button>
          </Link>
        </div>
        <div className="mb-2"></div>
        <Title title="About Your Developer" />
        <div className="mb-4"></div>
        <div className="about-section">
          <div className="flex-1">
            <About className="dev-icon" />
          </div>
          <div className="flex-1">
            <p className="about-content">
              My career to become as a developer was a shocking news to myself,
              had lot of opinions in learning techs/programming languages and
              how it works. I took a glance at some blogs from freecodecamp and
              in LinkedIn websites, what they discussed beyond imagination was
              programming in IT and not much about the software part. After the
              arrival of COVID-19, the usage of technology has increased all
              over the world, as a fresher I took chance to learn about
              CSS,HTML,Javascript from youtube tutorials and from udemy and
              started from basics. After learning I got to learn much about how
              these CSS,HTML and Javascript are used in advanced frameworks like
              React js, Vue js, Angular js, Next js, and the biggest advantage
              of these frameworks are to make the code reusable, edit so that
              the other developer can also edit and make use of it. Ofcourse
              errors do occur, but the way to sort out was challenging at
              initial then it became memorsied, so that I can identify and
              correct it. I instantly check the updates and follow the techs
              that get updated to frontend frameworks and backend frameworks. So
              days later, I started to create some challenging things using API
              and with dummy datas with style designs such as ecommerce shops ,
              fakeyoutube,blogs with authentication and saving user informations
              in backend.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutPage;
